import React from 'react'

import { useLastActiveMediaTrayCard } from '../../../../firebase/hooks/useTray'
import { useRole } from '../../../../global/blocs/roomInfo'
import { OnDemandPlayback } from '../../../../headless/src/components/on-demand-playback/on-demand-playback'
import { FloorHeadlessFeed } from '../FloorHeadlessFeed/FloorHeadlessFeed'
import { TrackPositioner } from '../TrackPositioner/TrackPositioner'

import { FloorTrayImage } from './FloorTrayImage/FloorTrayImage'

const FloorTrayFeed = () => {
  const lastActiveMediaCard = useLastActiveMediaTrayCard()
  const role = useRole()

  return (
    <TrackPositioner trackId={0} trackType="tray">
      {lastActiveMediaCard?.type === 'image' && (
        <FloorTrayImage trayCard={lastActiveMediaCard} />
      )}

      {role === 'headless' ? (
        <OnDemandPlayback isVisible={lastActiveMediaCard?.type === 'video'} />
      ) : (
        <FloorHeadlessFeed isVisible={lastActiveMediaCard?.type === 'video'} />
      )}
    </TrackPositioner>
  )
}

export { FloorTrayFeed }
